var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedPaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:payment-32-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.38281 5.03906C3.63689 5.03906 2.92152 5.33538 2.39407 5.86282C1.86663 6.39027 1.57031 7.10564 1.57031 7.85156V8.78906H19.0703V7.85156C19.0703 7.10564 18.774 6.39027 18.2465 5.86282C17.7191 5.33538 17.0037 5.03906 16.2578 5.03906H4.38281ZM1.57031 15.9766V10.0391H19.0703V15.9766C19.0703 16.7225 18.774 17.4379 18.2465 17.9653C17.7191 18.4927 17.0037 18.7891 16.2578 18.7891H4.38281C3.63689 18.7891 2.92152 18.4927 2.39407 17.9653C1.86663 17.4379 1.57031 16.7225 1.57031 15.9766ZM13.4453 13.7891C13.2796 13.7891 13.1206 13.8549 13.0034 13.9721C12.8862 14.0893 12.8203 14.2483 12.8203 14.4141C12.8203 14.5798 12.8862 14.7388 13.0034 14.856C13.1206 14.9732 13.2796 15.0391 13.4453 15.0391H15.3203C15.4861 15.0391 15.645 14.9732 15.7623 14.856C15.8795 14.7388 15.9453 14.5798 15.9453 14.4141C15.9453 14.2483 15.8795 14.0893 15.7623 13.9721C15.645 13.8549 15.4861 13.7891 15.3203 13.7891H13.4453Z",
    fill: "url(#paint0_linear_723_2122)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_723_2122",
    x1: 10.3203,
    y1: 5.03906,
    x2: 10.3203,
    y2: 18.7891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedPaymentIcon);
export default __webpack_public_path__ + "static/media/selectedPaymentIcon.e2744ceb2e8d58bf2d33eaff7ac97806.svg";
export { ForwardRef as ReactComponent };